export default __webpack_public_path__ + "static/media/sign-wise.f21546ad.png";